module.exports = __webpack_public_path__ + "static/media/mis_dashboard_inactive.cda7dd99.svg";